export type PriceIsDefaultPayloadKey = 'is_default' | 'isDefault'

export type PriceIsDefaultFromApi = {
  value: boolean
  payloadKey: PriceIsDefaultPayloadKey
}

export type PriceRuleIsDefaultState = {
  isDefault?: boolean
  isDefaultPayloadKey?: PriceIsDefaultPayloadKey
}

/** Prefer `is_default` when both keys exist (same as image mapping hydrate). */
export const resolvePriceIsDefaultFromApi = (source: unknown): PriceIsDefaultFromApi | null => {
  if (source == null || typeof source !== 'object') return null
  const record = source as Record<string, unknown>
  if (Object.prototype.hasOwnProperty.call(record, 'is_default')) {
    return { value: Boolean(record.is_default), payloadKey: 'is_default' }
  }
  if (Object.prototype.hasOwnProperty.call(record, 'isDefault')) {
    return { value: Boolean(record.isDefault), payloadKey: 'isDefault' }
  }
  return null
}

export const resolvePriceRuleIsDefaultForSave = (
  rule: PriceRuleIsDefaultState,
  priceField?: unknown | null
): PriceIsDefaultFromApi | null => {
  if (
    typeof rule.isDefault === 'boolean' &&
    (rule.isDefaultPayloadKey === 'is_default' || rule.isDefaultPayloadKey === 'isDefault')
  ) {
    return { value: rule.isDefault, payloadKey: rule.isDefaultPayloadKey }
  }
  return resolvePriceIsDefaultFromApi(priceField)
}

export type PriceIsDefaultPayloadTarget = {
  isDefault?: boolean
  is_default?: boolean
}

export const applyPriceIsDefaultToPayload = (
  payload: PriceIsDefaultPayloadTarget,
  resolved: PriceIsDefaultFromApi | null
): void => {
  if (!resolved) return
  if (resolved.payloadKey === 'is_default') {
    payload.is_default = resolved.value
  } else {
    payload.isDefault = resolved.value
  }
}
